export class AuthConstants {
  public static readonly authority = process.env.REACT_APP_AUTH_ENDPOINT
  public static readonly clientId = process.env.REACT_APP_CLIENT_ID
  public static readonly redirectUri = process.env.REACT_APP_AUTH_REDIRECT_URI
  public static readonly scope = 'openid profile ic roles icResources icClaims'
  public static readonly responseType = 'id_token token'
}
